module.exports = "/img/1.svg?4a1eb2f5b89de9e34832d8f22acffc1f";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/spinner/img/1.svg
// module id = aSgp
// module chunks = 83